var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLdap = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.842 2.775A2 2 0 0 1 3.2 2.25h3.09l2 1.818h4.51a2 2 0 0 1 1.358.525c.371.344.592.823.592 1.336v5.96c0 .513-.22.992-.592 1.336a2 2 0 0 1-1.358.525H3.2a2 2 0 0 1-1.358-.525 1.821 1.821 0 0 1-.592-1.336V4.11c0-.513.22-.992.592-1.336zM3.2 3.75a.501.501 0 0 0-.339.126.322.322 0 0 0-.111.235v7.778c0 .076.032.162.111.235a.5.5 0 0 0 .339.126H6v-.75a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.75h2.8a.501.501 0 0 0 .339-.126.322.322 0 0 0 .111-.235v-5.96a.322.322 0 0 0-.111-.235.501.501 0 0 0-.339-.126H7.71l-2-1.818H3.2z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLdap);
export default ForwardRef;